import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { toast } from 'sonner';
import { useTenant } from '../../context/TenantContext';
import api from '../../utils/api';

const OperatorRequestBase = ({ title, description, requestType, FormComponent, backHref }) => {
  const { activeTenant } = useTenant();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [createdRequest, setCreatedRequest] = useState(null);
  const [formData, setFormData] = useState({});

  const handleSubmit = async (data) => {
    if (!activeTenant) {
      toast.error('Selecciona un cliente primero');
      return;
    }
    try {
      setSubmitting(true);
      setFormData(data);
      const response = await api.post('/requests/wizard', {
        tenant_id: activeTenant,
        request_type: requestType,
        form_data: data,
        attachments: [],
      });
      setCreatedRequest(response.data);
      toast.success('Solicitud creada');
    } catch (error) {
      const errorMsg = error.response?.data?.detail || 'Error al crear la solicitud';
      toast.error(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  const handleReset = () => {
    setCreatedRequest(null);
    setFormData({});
  };

  if (!activeTenant) {
    return (
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-heading font-bold mb-2">{title}</h1>
        <p className="text-muted-foreground">Selecciona un cliente para continuar.</p>
      </div>
    );
  }

  if (createdRequest) {
    return (
      <div className="max-w-3xl mx-auto space-y-6">
        <Card>
          <CardHeader>
            <CardTitle>Solicitud creada</CardTitle>
            <CardDescription>{title}</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="rounded-lg border border-slate-200 bg-slate-50 p-4">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <div>
                  <div className="text-sm text-muted-foreground">ID</div>
                  <div className="font-mono text-xs">{createdRequest.id}</div>
                </div>
                <Badge variant="secondary">{createdRequest.status}</Badge>
              </div>
              {createdRequest.tasks?.[0] && (
                <div className="mt-3 text-sm text-muted-foreground">
                  SLA: {new Date(createdRequest.tasks[0].due_date).toLocaleDateString('es-ES')}
                </div>
              )}
            </div>

            <div className="flex flex-wrap gap-2">
              <Button onClick={handleReset} variant="outline">
                Nueva solicitud
              </Button>
              {backHref && (
                <Button onClick={() => navigate(backHref)} variant="ghost">
                  Volver al workspace
                </Button>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto space-y-4">
      <div>
        <h1 className="text-3xl font-heading font-bold">{title}</h1>
        <p className="text-muted-foreground">{description}</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Datos de la solicitud</CardTitle>
          <CardDescription>Completa la informacion necesaria.</CardDescription>
        </CardHeader>
        <CardContent>
          <FormComponent initialData={formData} onSubmit={handleSubmit} />
          {submitting && <p className="text-sm text-muted-foreground mt-3">Enviando...</p>}
        </CardContent>
      </Card>
    </div>
  );
};

export default OperatorRequestBase;
